<div class="component-viewer">
    <mat-card>
        <mat-card-header>
            <h2>Widget</h2>
        </mat-card-header>
        <mat-card-content>
            <div class="row">
                <div class="col-6">
                    <div style="display: flex; align-items: baseline;">
                        <p style="margin-right: 10px;">Enter the code below on your webpage</p>
                        <button mat-icon-button (click)="copyText()"><mat-icon>content_copy</mat-icon></button>
                    </div>
                    <div class="row">
                        <code>{{iframeCodeHtml}}</code><br />
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <p>Preview</p>
                    </div>
                    <div class="row">
                        <iframe [src]="url" height="740"></iframe>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>